export default {
  url: 'https://dev-607424.okta.com',
  issuer: 'https://dev-607424.okta.com/oauth2/default',
  redirectUri: window.location.origin + '/implicit/callback',
  clientId: '0oa4pyl2rJXBC6sHH4x6',
  pkce: true
};
